export const OLD_TOKEN_COOKIE_NAME = process.env.NEXT_PUBLIC_LOGIN_COOKIE_NAME || "payse_token_v2";
export const AUTH_TOKEN_COOKIE_NAME = "payse_token_v3";
